import { type InsuranceCorporateIdentity } from "../types";

export function IkkBrandenburgBerlinLogo({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158 400V284.881H179V400H158ZM158 263.831V243H179V263.831H158Z"
        fill="#010202"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213 400V232H233.973V339.529L283.497 284.555H304.58L258.79 335.791L316 400H287.999L233.973 339.749V400H213Z"
        fill="#010202"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M333 400V232H353.996V339.529L403.682 284.555H424.458L378.839 335.791L436 400H407.969L353.996 339.749V400H333Z"
        fill="#010202"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M395.577 151.944C341.339 94.869 219.879 113.014 137.805 190.874C69.9244 255.318 60.4629 332.298 103.37 373.978C52.9817 330.429 62.2232 246.52 137.695 176.468C227.14 93.6593 360.482 73.2045 419.561 133.799C453.227 168.33 446.516 222.106 419.781 270.274H433.534C462.468 218.477 469.399 161.402 434.194 122.802C370.053 52.3099 221.639 73.4245 123.173 167.67C35.8189 251.359 35.0487 350.554 105.79 392.673C113.381 397.292 121.523 400.921 130.324 404V374.418C78.9459 337.687 84.5568 259.167 153.978 194.284C232.201 121.042 347.61 103.777 399.978 156.783C399.978 156.783 397.118 153.374 395.577 151.944Z"
        fill="white"
      />
    </svg>
  );
}

export const IkkBrandenburgBerlin: InsuranceCorporateIdentity = {
  id: "ikk-brandenburg-berlin",
  name: "IKK Brandenburg und Berlin",
  logo: IkkBrandenburgBerlinLogo,
  backgroundColor: "#43ABE1",
  textColor: "#FFFFFF",
  wildcard: "brandenburg",
  type: "statutory",
};
